/* ============================================================
   PICHEA — Eventos · interacciones
   Vanilla JS, sin dependencias.
   Port 1:1 del comportamiento de "Eventos Pichea.dc.html":
     · reveals al scroll (IntersectionObserver)
     · cascada por grupo (data-pi-stagger)
     · contadores numéricos
     · CTA sticky en móvil
   Respeta prefers-reduced-motion y el editor de Shopify.
   ============================================================ */
(function () {
  'use strict';

  // Cada sección incluye el snippet de assets, así que este archivo puede
  // cargarse varias veces en la misma página. Solo la primera hace algo.
  if (window.__picheaEventosInit) return;
  window.__picheaEventosInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var io = null;

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ---------- 1) Reveals ---------- */
  function initReveals(root) {
    var els = $all('.pi-rv:not(.is-in)', root);
    if (!els.length) return;

    // Cascada: cada grupo reparte el delay entre sus hijos revelables.
    $all('[data-pi-stagger]', root).forEach(function (group) {
      if (group.dataset.piStaggerDone) return;
      group.dataset.piStaggerDone = '1';
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (child.classList.contains('pi-rv')) {
          child.style.transitionDelay = (i * 90) + 'ms';
        }
      });
    });

    // En el editor de Shopify el IntersectionObserver no es fiable dentro del
    // iframe, y con reduced-motion no queremos animar: mostramos de una.
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.style.transitionDelay = '';
        el.classList.add('is-in');
      });
      return;
    }

    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add('is-in');
          io.unobserve(el);
          // Limpiamos el delay para que no afecte transiciones posteriores.
          if (el.style.transitionDelay) {
            setTimeout(function () { el.style.transitionDelay = ''; }, 1200);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2) Contadores ---------- */
  function initCounters(root) {
    $all('[data-pi-count]', root).forEach(function (el) {
      if (el.dataset.piCountDone) return;
      el.dataset.piCountDone = '1';

      var target = parseInt(el.dataset.piCount, 10);
      var suffix = el.dataset.piSuffix || '';
      if (isNaN(target)) return;

      if (reduce || designMode || !('IntersectionObserver' in window)) {
        el.textContent = target + suffix;
        return;
      }

      var co = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        co.disconnect();
        var start = performance.now();
        var dur = 1400;
        (function tick(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(start);
      }, { threshold: 0.5 });
      co.observe(el);
    });
  }

  /* ---------- 3) CTA sticky en móvil ---------- */
  function initSticky() {
    var bar = document.querySelector('.pi-ev__sticky');
    var hero = document.querySelector('[data-pi-hero]');
    var form = document.getElementById('pi-ev-cotiza');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    if (bar.dataset.piStickyDone) return;
    bar.dataset.piStickyDone = '1';

    var pastHero = false;
    var atForm = false;
    function sync() { bar.classList.toggle('is-in', pastHero && !atForm); }

    new IntersectionObserver(function (e) {
      pastHero = !e[0].isIntersecting;
      sync();
    }, { threshold: 0 }).observe(hero);

    if (form) {
      new IntersectionObserver(function (e) {
        atForm = e[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(form);
    }
  }

  /* ---------- 4) Scroll suave a una sección ---------- */
  function initAnchors(root) {
    $all('[data-pi-scroll]', root).forEach(function (el) {
      if (el.dataset.piScrollDone) return;
      el.dataset.piScrollDone = '1';
      el.addEventListener('click', function (ev) {
        var target = document.getElementById(el.dataset.piScroll);
        if (!target) return;
        ev.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- 5) Éxito del formulario ---------- */
  /* La tienda tiene la protección anti-spam de Shopify: el POST pasa por
     /challenge y al volver se pierde form.posted_successfully?. Por eso el
     form lleva return_to con ?enviado=1 y aquí detectamos ese parámetro:
     ocultamos el formulario, mostramos la confirmación y hacemos scroll. */
  function initFormSuccess() {
    if (window.location.search.indexOf('enviado=1') === -1) return;
    var ok = document.querySelector('[data-pi-form-ok]');
    if (!ok || ok.dataset.piOkDone) return;
    ok.dataset.piOkDone = '1';
    var form = document.getElementById('pi-ev-form');
    if (form) form.style.display = 'none';
    ok.hidden = false;
    var top = ok.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: top, behavior: 'auto' });
  }

  /* ---------- 6) UTM del anuncio que trajo el lead ---------- */
  /* Los anuncios de Meta llegan con ?utm_source=…&utm_content=A_reel. Se
     guardan 30 días (por si la persona vuelve sin la URL del anuncio) y se
     copian a campos ocultos del form, así salen en el email de Shopify y en
     el evento de Klaviyo (de ahí los lee Make → data store). */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  var UTM_STORE = 'pi_ev_utm';
  var UTM_DAYS = 30;
  var utm = {};

  function readUtm() {
    var fromUrl = {};
    var hasUrl = false;
    var params = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach(function (k) {
      var v = (params.get(k) || '').trim().slice(0, 100);
      if (v) { fromUrl[k] = v; hasUrl = true; }
    });
    try {
      if (hasUrl) {
        fromUrl._t = Date.now();
        localStorage.setItem(UTM_STORE, JSON.stringify(fromUrl));
        return fromUrl;
      }
      var saved = JSON.parse(localStorage.getItem(UTM_STORE) || 'null');
      if (saved && Date.now() - (saved._t || 0) < UTM_DAYS * 864e5) return saved;
    } catch (e) { /* sin storage: solo vale lo de la URL */ }
    return fromUrl;
  }

  function initUtm() {
    var form = document.getElementById('pi-ev-form');
    if (!form || form.dataset.piUtmDone) return;
    form.dataset.piUtmDone = '1';
    utm = readUtm();
    UTM_KEYS.forEach(function (k) {
      if (!utm[k]) return;
      var name = 'contact[' + k + ']';
      var input = form.querySelector('[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = utm[k];
    });
  }

  /* ---------- 7) Evento a Klaviyo al enviar la cotización ---------- */
  /* Manda "Cotización de evento" a Klaviyo (API pública, keepalive para que
     sobreviva a la navegación del POST). Un flow de Klaviyo triggered por esa
     métrica le envía al cliente el email de agradecimiento + próximos pasos.
     El email a la tienda (form de Shopify) sigue igual — esto es en paralelo. */
  var KLAVIYO_COMPANY_ID = 'Uu79uz';
  function initKlaviyoEvent() {
    var form = document.getElementById('pi-ev-form');
    if (!form || form.dataset.piKlDone) return;
    form.dataset.piKlDone = '1';
    form.addEventListener('submit', function () {
      try {
        var val = function (n) {
          var el = form.querySelector('[name="contact[' + n + ']"]');
          return el ? el.value : '';
        };
        var email = val('email');
        if (!email) return;
        var payload = {
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Cotización de evento' } } },
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: val('name'),
                    properties: { 'Teléfono cotización': val('phone') }
                  }
                }
              },
              properties: {
                'Fecha del evento': val('Fecha del evento'),
                'Tipo de evento': val('Tipo de evento'),
                'Invitados': val('Invitados'),
                'Ubicación': val('Ubicación'),
                'Paquete': val('Paquete'),
                'Mensaje': val('body'),
                'Página': window.location.pathname,
                'utm_source': utm.utm_source || '',
                'utm_medium': utm.utm_medium || '',
                'utm_campaign': utm.utm_campaign || '',
                'utm_content': utm.utm_content || ''
              }
            }
          }
        };
        fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(payload)
        });
      } catch (e) { /* nunca bloquear el envío del formulario */ }
    });
  }

  function init(root) {
    initReveals(root);
    initCounters(root);
    initAnchors(root);
    initSticky();
    initFormSuccess();
    initUtm();
    initKlaviyoEvent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // El editor de Shopify recarga secciones sueltas: re-inicializamos esa sección.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
